import type { CmsCopyStore, CmsSetType } from "@akina/infra";
import {
  setCmsCopy,
  getLegalPage,
  getIFULanguages,
  getReleaseNotes,
  getSounds,
  getTreatmentTemplateDetails,
  getExerciseDetails,
  getTreatmentTemplatesDetails,
  getTreatmentTemplatesListDetails,
  getSoundByKey,
  getExerciseMistakesText,
  getExerciseMistakeVideos,
  getImageByKey,
  getAllExerciseNames,
} from "@akina/utils";
import { create } from "zustand";

export const useCmsCopyStore = create<CmsCopyStore>()((set, get) => ({
  cmsCopy: null,
  isLoadingCmsCopy: true,

  actions: {
    setIsLoadingCmsCopy: (value: boolean) => set({ isLoadingCmsCopy: value }),
    getLegalPage: getLegalPage(get),
    getIFULanguages: getIFULanguages(get),
    getReleaseNotes: getReleaseNotes(get),
    getSounds: getSounds(get),
    getTreatmentTemplateDetails: getTreatmentTemplateDetails(get),
    getTreatmentTemplatesDetails: getTreatmentTemplatesDetails(get),
    getTreatmentTemplatesListDetails: getTreatmentTemplatesListDetails(get),
    getExerciseDetails: getExerciseDetails(get),
    setCmsCopy: setCmsCopy(set as CmsSetType),
    getSoundByKey: getSoundByKey(get),
    getExerciseMistakesText: getExerciseMistakesText(get),
    getExerciseMistakeVideos: getExerciseMistakeVideos(get),
    getImageByKey: getImageByKey(get),
    getAllExerciseNames: getAllExerciseNames(get),
  },
}));
